/** @format */

import SttGpsSahifa from "./SttGpsSahifa";

export default SttGpsSahifa;
